import { nameValueArrayFromObject } from '../utils.js';
import { getGuardianshipTypeDisplay } from './guardianshipTypes.js';
export const relationshipTypeDisplay = {
    SELF: 'Self',
    NATURAL_MOTHER: 'Natural mother',
    NATURAL_FATHER: 'Natural father',
    NATURAL_PARENT: 'Natural parent',
    STEPMOTHER: 'Stepmother',
    STEPFATHER: 'Stepfather',
    STEP_PARENT: 'Step parent',
    ADOPTIVE_MOTHER: 'Adoptive mother',
    ADOPTIVE_FATHER: 'Adoptive father',
    ADOPTIVE_PARENT: 'Adoptive parent',
    FOSTER_MOTHER: 'Foster mother',
    FOSTER_FATHER: 'Foster father',
    FOSTER_PARENT: 'Foster parent',
    GRANDMOTHER: 'Grandmother',
    GRANDFATHER: 'Grandfather',
    GRANDPARENT: 'Grandparent',
    AUNT: 'Aunt',
    UNCLE: 'Uncle',
    BROTHER: 'Brother',
    SISTER: 'Sister',
    SIBLING: 'Sibling',
    SPOUSE: 'Spouse',
    SIGNIFICANT_OTHER: 'Significant other',
    COUSIN: 'Cousin',
    OTHER_FAMILY_MEMBER: 'Other family member',
    UNRELATED_FRIEND: 'Unrelated friend',
    NEIGHBOR: 'Neighbor',
    ROOMMATE: 'Roommate',
    OTHER_NON_FAMILY_MEMBER: 'Other non family member',
    EMPLOYER: 'Employer',
    INSURANCE_COMPANY: 'Insurance company',
    FEDERAL_AGENCY: 'Federal agency',
    STATE_AGENCY: 'State agency',
    OTHER_ORGANIZATION: 'Other organization',
    NANNY: 'Nanny',
    OTHER: 'Other',
};
export const familyMemberHistoryRelationshipTypeDisplay = {
    NATURAL_MOTHER: relationshipTypeDisplay['NATURAL_MOTHER'],
    NATURAL_FATHER: relationshipTypeDisplay['NATURAL_FATHER'],
    NATURAL_PARENT: relationshipTypeDisplay['NATURAL_PARENT'],
    MATERNAL_GRANDMOTHER: 'Maternal grandmother',
    PATERNAL_GRANDMOTHER: 'Paternal grandmother',
    GRANDMOTHER: relationshipTypeDisplay['GRANDMOTHER'],
    MATERNAL_GRANDFATHER: 'Maternal grandfather',
    PATERNAL_GRANDFATHER: 'Paternal grandfather',
    GRANDFATHER: relationshipTypeDisplay['GRANDFATHER'],
    MATERNAL_GRANDPARENT: 'Maternal grandparent',
    PATERNAL_GRANDPARENT: 'Paternal grandparent',
    GRANDPARENT: relationshipTypeDisplay['GRANDPARENT'],
    MATERNAL_AUNT: 'Maternal aunt',
    PATERNAL_AUNT: 'Paternal aunt',
    AUNT: relationshipTypeDisplay['AUNT'],
    MATERNAL_UNCLE: 'Maternal uncle',
    PATERNAL_UNCLE: 'Paternal uncle',
    UNCLE: relationshipTypeDisplay['UNCLE'],
    MATERNAL_COUSIN: 'Maternal cousin',
    PATERNAL_COUSIN: 'Paternal cousin',
    COUSIN: relationshipTypeDisplay['COUSIN'],
    SISTER: relationshipTypeDisplay['SISTER'],
    BROTHER: relationshipTypeDisplay['BROTHER'],
    SIBLING: relationshipTypeDisplay['SIBLING'],
    OTHER_FAMILY_MEMBER: relationshipTypeDisplay['OTHER_FAMILY_MEMBER'],
};
export const relationshipTypes = nameValueArrayFromObject(relationshipTypeDisplay);
export const familyMemberHistoryRelationshipTypes = nameValueArrayFromObject(familyMemberHistoryRelationshipTypeDisplay);
export const relationshipCategoryDisplay = {
    PARENT: "Patient's parent",
    FAMILY_MEMBER: "Patient's family member",
    NON_FAMILY_MEMBER: "Patient's non-family member",
    OTHER: 'Other',
};
export const relationshipCategories = nameValueArrayFromObject(relationshipCategoryDisplay);
export const getRelationshipCategoryDescription = ({ category, userIsCaregiver, }) => {
    const pronoun = userIsCaregiver ? 'You' : 'They';
    switch (category) {
        case 'PARENT':
            return `${pronoun} are a biological/natural or legal parent to the patient.`;
        case 'FAMILY_MEMBER':
            return `${pronoun} have a non-parent family member relationship to the patient.`;
        case 'NON_FAMILY_MEMBER':
            return `${pronoun} have a non-family member relationship to the patient.`;
        case 'OTHER':
            return `${pronoun} represent a government or third party entity involved with the patient's healthcare.`;
    }
};
export const relationshipTypeToCategory = {
    SELF: 'OTHER',
    NATURAL_MOTHER: 'PARENT',
    NATURAL_FATHER: 'PARENT',
    NATURAL_PARENT: 'PARENT',
    STEPMOTHER: 'PARENT',
    STEPFATHER: 'PARENT',
    STEP_PARENT: 'PARENT',
    ADOPTIVE_MOTHER: 'PARENT',
    ADOPTIVE_FATHER: 'PARENT',
    ADOPTIVE_PARENT: 'PARENT',
    FOSTER_MOTHER: 'PARENT',
    FOSTER_FATHER: 'PARENT',
    FOSTER_PARENT: 'PARENT',
    GRANDMOTHER: 'FAMILY_MEMBER',
    GRANDFATHER: 'FAMILY_MEMBER',
    GRANDPARENT: 'FAMILY_MEMBER',
    AUNT: 'FAMILY_MEMBER',
    UNCLE: 'FAMILY_MEMBER',
    BROTHER: 'FAMILY_MEMBER',
    SISTER: 'FAMILY_MEMBER',
    SIBLING: 'FAMILY_MEMBER',
    SPOUSE: 'FAMILY_MEMBER',
    SIGNIFICANT_OTHER: 'FAMILY_MEMBER',
    COUSIN: 'FAMILY_MEMBER',
    OTHER_FAMILY_MEMBER: 'FAMILY_MEMBER',
    UNRELATED_FRIEND: 'NON_FAMILY_MEMBER',
    NEIGHBOR: 'NON_FAMILY_MEMBER',
    ROOMMATE: 'NON_FAMILY_MEMBER',
    OTHER_NON_FAMILY_MEMBER: 'NON_FAMILY_MEMBER',
    EMPLOYER: 'OTHER',
    INSURANCE_COMPANY: 'OTHER',
    FEDERAL_AGENCY: 'OTHER',
    STATE_AGENCY: 'OTHER',
    OTHER_ORGANIZATION: 'OTHER',
    NANNY: 'NON_FAMILY_MEMBER',
    OTHER: 'OTHER',
};
export const relationshipTypeToGuardianshipStatus = {
    SELF: 'NATURAL',
    NATURAL_MOTHER: 'NATURAL',
    NATURAL_FATHER: 'NATURAL',
    NATURAL_PARENT: 'NATURAL',
    STEPMOTHER: 'LEGAL',
    STEPFATHER: 'LEGAL',
    STEP_PARENT: 'LEGAL',
    ADOPTIVE_MOTHER: 'LEGAL',
    ADOPTIVE_FATHER: 'LEGAL',
    ADOPTIVE_PARENT: 'LEGAL',
    FOSTER_MOTHER: 'LEGAL',
    FOSTER_FATHER: 'LEGAL',
    FOSTER_PARENT: 'LEGAL',
    GRANDMOTHER: 'LEGAL',
    GRANDFATHER: 'LEGAL',
    GRANDPARENT: 'LEGAL',
    AUNT: 'LEGAL',
    UNCLE: 'LEGAL',
    BROTHER: 'LEGAL',
    SISTER: 'LEGAL',
    SIBLING: 'LEGAL',
    SPOUSE: 'LEGAL',
    SIGNIFICANT_OTHER: 'LEGAL',
    COUSIN: 'LEGAL',
    OTHER_FAMILY_MEMBER: 'LEGAL',
    UNRELATED_FRIEND: 'LEGAL',
    NEIGHBOR: 'LEGAL',
    ROOMMATE: 'LEGAL',
    OTHER_NON_FAMILY_MEMBER: 'LEGAL',
    EMPLOYER: 'LEGAL',
    INSURANCE_COMPANY: 'LEGAL',
    FEDERAL_AGENCY: 'LEGAL',
    STATE_AGENCY: 'LEGAL',
    OTHER_ORGANIZATION: 'LEGAL',
    NANNY: 'LEGAL',
    OTHER: 'LEGAL',
};
/**
 * Formats a relationship's display details (guardianship, relationship type, guarantor) as a string.
 * Example: 'Legal guardian • Grandmother • Guarantor'
 */
export function formatRelationshipDisplay({ guardianshipType, relationshipType, isGuarantor, includeNonGuarantor = false, separatorType = 'middot', }) {
    const guardianshipDisplay = getGuardianshipTypeDisplay(guardianshipType);
    const separatorMap = {
        middot: ' · ', // U+00B7
        bullet: ' • ', // U+2022
    };
    const separator = separatorMap[separatorType] ?? separatorMap.middot;
    return [
        guardianshipDisplay,
        relationshipTypeDisplay[relationshipType],
        isGuarantor ? 'Guarantor' : includeNonGuarantor ? 'Non-guarantor' : null,
    ]
        .filter(Boolean)
        .join(separator);
}
//# sourceMappingURL=relationshipTypes.js.map